// src/config/theme.ts
import { extendTheme, type ThemeConfig } from '@chakra-ui/react';

// Configuration pour forcer le dark mode
const config: ThemeConfig = {
  initialColorMode: 'dark',
  useSystemColorMode: false, // Désactiver la détection automatique du système
}

const theme = extendTheme({
  config,
  styles: {
    global: (props: any) => ({
      // Applique les styles au body - toujours en mode sombre
      body: {
        // Utilise les variables de couleur de votre fichier index.css
        bg: 'var(--nuit-profonde)',
        color: 'var(--texte-clair)',
      },
      // Force les couleurs pour tous les éléments
      '*': {
        colorScheme: 'dark',
      }
    }),
  },
  // Override des couleurs par défaut de Chakra pour forcer le mode sombre
  colors: {
    gray: {
      50: '#F7FAFC',
      100: '#EDF2F7',
      200: '#E2E8F0',
      300: '#CBD5E0',
      400: '#A0AEC0',
      500: '#718096',
      600: '#4A5568',
      700: '#2D3748',
      800: '#1A202C',
      900: '#171923',
    },
  },
  components: {
    Modal: {
      baseStyle: (props: any) => ({
        dialog: {
          bg: 'var(--gris-bleute)',
          color: 'var(--texte-clair)',
        },
        header: {
          bg: 'var(--gris-bleute)',
          color: 'var(--texte-clair)',
        },
        body: {
          bg: 'var(--gris-bleute)',
          color: 'var(--texte-clair)',
        },
        footer: {
          bg: 'var(--gris-bleute)',
          color: 'var(--texte-clair)',
        },
      }),
    },
    Button: {
      baseStyle: {
        _focus: {
          boxShadow: 'none',
        },
      },
      variants: {
        solid: (props: any) => {
          const { colorScheme } = props;
          if (colorScheme === 'gray') {
            return {
              bg: 'gray.600',
              color: 'white',
              _hover: {
                bg: 'gray.500',
              },
              _active: {
                bg: 'gray.700',
              },
            };
          }
          return {};
        },
      },
    },
  },
});

export default theme;